import { CompanyLicense } from '../components';
import { useCompanyLicense } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyLicenseStep = ({ canGoBack }: PageComponentProps) => {
  const {
    files,
    initialValues,
    submitDisabled,
    submitLoading,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
    onRemoveFilesByServerIds,
  } = useCompanyLicense();

  return (
    <CompanyLicense
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onRemoveFilesByServerIds={onRemoveFilesByServerIds}
      onSubmit={onSubmit}
    />
  );
};
